import { Button, Empty, Flex, Typography } from "antd";
import { useNavigation } from "@refinedev/core";
import { useContext } from "react";
import { SmartMenuContext } from "@/config/context/smartMenuContext";

const { Text } = Typography;

export const ConversationsEmptyChannels = ({ store }: { store?: string }) => {
  const { push } = useNavigation();
  const { setSmartMenuState, setSmartMenuName, setSmartMenuType } = useContext(SmartMenuContext);

  const handleConfigureChannels = () => {
    if (!store) return;
    setSmartMenuType("stores");
    setSmartMenuName(store);
    setSmartMenuState(true);
    push(`/stores/channels/${store}`);
  };

  return (
    <Flex
      align="center"
      justify="center"
      vertical
      gap={16}
      style={{ flex: 1, height: "100%" }}
    >
      <Empty
        description={
          <Text style={{ color: "#262626", display: "block", textAlign: "center", fontSize: 16, fontWeight: 500 }}>
            Viculá el WhatsApp y Email para centralizar los mensajes,
            <br />
            presupuestos y pedidos de tus clientes desde aquí.
          </Text>
        }
      />
      <Button
        type="primary"
        disabled={!store}
        onClick={handleConfigureChannels}
      >
        Configurar canales
      </Button>
    </Flex>
  );
};
